module.exports = __webpack_public_path__ + "img/ddwu_gallery1.cc30ecfd.jpg";